// extracted by mini-css-extract-plugin
module.exports = {"AddEmployee":"AddEmployee_AddEmployee__2BAqe"};